import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Header = () => (
  <motion.header
    className="hero"
    initial={{ opacity: 0, y: -30 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
  >
    <meta name="facebook-domain-verification" content="m0s86pwebchltewjsrangxlrxsvhet" />
    <h1>QMX Technology</h1>
    <p>Scalable, high‑volume communication infrastructure &amp; software solutions</p>
    <div className="cta-group">
      <a href="mailto:kwuimi@qmxtechnology.com" className="cta">Get Started</a>
      <Link to="/communication" className="cta-outline">Explore Services</Link>
    </div>
  </motion.header>
);

export default Header;
